module.exports = __webpack_public_path__ + "static/media/sports3.76f9a526.jpg";